
const formList = {
    dataChangeList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "chanName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "名称",
        },
        {
            entityField: "gchmType",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "变更类型",
        },
    ],
    dataChangeHistory: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "chanName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "名称",
        },
        {
            entityField: "createrName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "变更人",
        },
        {
            entityField: "gchmState",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "状态",
        },
        {
            entityField: "gchmType",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "变更类型",
        },
    ],
}
export default formList